module.exports = __webpack_public_path__ + "img/no.fcb35e38.svg";